"use client";

import React from "react";
import { Check, Sparkles } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const pricingPlans = [{
  name: "Mehanika",
  price: "15€",
  period: "od",
  description: "Osnovni i napredni mehanički popravci za sigurnu i stabilnu vožnju gradom.",
  features: ["Zamjena guma i zračnica", "Podešavanje kočionog sustava", "Zamjena ležajeva kotača", "Učvršćivanje konstrukcije"],
  isPopular: false,
  buttonText: "Rezerviraj",
  buttonLink: "/ServicesPage"
}, {
  name: "Servis Baterija",
  price: "40€",
  period: "od",
  description: "Specijalizirana dijagnostika i obnova baterijskih paketa za maksimalni domet.",
  features: ["BMS dijagnostika i popravak", "Zamjena neispravnih ćelija", "Povećanje kapaciteta (Range)", "Punjenje duboko ispražnjenih", "Izrada novih paketa"],
  isPopular: true,
  buttonText: "Rezerviraj",
  buttonLink: "/BatteryServicePage"
}, {
  name: "Elektronika",
  price: "30€",
  period: "od",
  description: "Precizni popravci upravljačke elektronike, motora i digitalnih sustava.",
  features: ["Popravak kontrolera", "Zamjena LCD zaslona", "Sređivanje instalacija", "Programiranje i firmware", "Popravak motora"],
  isPopular: false,
  buttonText: "Rezerviraj",
  buttonLink: "/ServicesPage"
}];
export default function ChooseYourPace() {
  return <section data-section-id="224055" id="cjenik-servisa" className="bg-background text-foreground py-24 px-6 relative overflow-hidden">
      {}
      <style>{`
        @keyframes shimmer {
          100% { transform: translateX(100%); }
        }
      `}</style>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-7xl font-default font-bold uppercase tracking-tight mb-6 text-primary">
            Cjenik servisa
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-3xl mx-auto font-default">
            Pregled cijena najčešćih popravaka. Napomena: Konačna cijena ovisi o cijeni rezervnih dijelova i nalazu dijagnostike.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 items-center">
          {pricingPlans.map((plan, i) => <div data-index={i} key={plan.name} className={`relative transition-all duration-500 ${plan.isPopular ? 'lg:scale-110 z-20' : 'z-10'}`}>
              {plan.isPopular && <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-primary-foreground text-primary px-5 py-1.5 rounded-full text-sm font-bold uppercase tracking-widest flex items-center gap-2 z-30 shadow-[0_0_20px_hsl(157_100%_50%_/_0.4)]">
                  <Sparkles className="w-4 h-4" />
                  Najtraženije
                </div>}

              <Card className={`h-full flex flex-col bg-card/60 backdrop-blur-xl transition-colors duration-300 rounded-sm ${plan.isPopular ? 'border-primary-foreground shadow-[0_0_40px_hsl(157_100%_50%_/_0.15)] relative overflow-hidden' : 'border-border/40 hover:border-primary/30'}`}>
                {plan.isPopular && <div className="absolute inset-0 bg-gradient-to-b from-primary-foreground/5 to-transparent pointer-events-none" />}

                <CardHeader className="text-center pb-4 relative z-10 pt-10">
                  <CardTitle className="text-2xl font-bold font-default text-primary tracking-wide">
                    {plan.name}
                  </CardTitle>
                  <CardDescription className="font-default text-muted-foreground mt-2">
                    {plan.description}
                  </CardDescription>
                </CardHeader>

                <CardContent className="text-center relative z-10 flex-grow">
                  <div className="my-8 flex items-baseline justify-center gap-1">
                    <span className="text-muted-foreground font-mono font-medium text-xl mr-1">
                      {plan.period}
                    </span>
                    <span className="text-7xl font-mono font-bold tracking-tighter text-primary">
                      {plan.price}
                    </span>
                  </div>

                  <ul className="space-y-5 text-left mt-10">
                    {plan.features.map((feature, j) => <li data-index={j} key={j} className="flex items-start gap-4 font-default text-sm md:text-base">
                        <Check className="w-5 h-5 text-primary-foreground shrink-0 mt-0.5" strokeWidth={3} />
                        <span className="text-muted-foreground font-medium">{feature}</span>
                      </li>)}
                  </ul>
                </CardContent>

                <CardFooter className="relative z-10 mt-auto pt-10 pb-8">
                  <Button asChild variant={plan.isPopular ? "default" : "outline"} className={`w-full h-14 text-lg font-bold tracking-wide uppercase rounded-sm ${plan.isPopular ? 'bg-primary-foreground text-primary hover:bg-primary-foreground/90 border-none relative overflow-hidden group' : 'border-primary/30 hover:bg-primary/5 text-primary'}`}>
                    <Link to={plan.buttonLink}>
                      {plan.isPopular && <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent animate-[shimmer_2.5s_infinite]" />}
                      <span className="relative z-10">{plan.buttonText}</span>
                    </Link>
                  </Button>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}